<div class="collabora-editor-container">

  <div *ngIf="isLoading" class="loader">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Inicializando editor...</p>
    <button style="display: none;" type="button" mat-stroked-button (click)="abrirManual()" matTooltip="Si el editor no carga, puedes abrirlo manualmente. No olvides guardar tu redacci&oacute;n &#128190;.">
      <mat-icon>open_in_new</mat-icon>
      Abrir manualmente
    </button>
  </div>

  <div *ngIf="errorMessage" class="error-container">
    <mat-icon>error_outline</mat-icon>
    <p>{{ errorMessage }}</p>
    <button mat-stroked-button (click)="reload()">
      <mat-icon>refresh</mat-icon>
      Reintentar
    </button>
  </div>

  <iframe *ngIf="collaboraUrl && !errorMessage" 
  #collaboraFrame 
  [src]="collaboraUrl | safeResourceUrl"
  name="collabora_frame" 
  allow="clipboard-read *; clipboard-write *; fullscreen"
  allowfullscreen >
  </iframe>  

</div>